/* eslint-disable react-hooks/exhaustive-deps */
import { Brand } from '@awaze/design-system.components.awaze-theme-provider'
import React, { ReactNode, useEffect } from 'react'
import { PostBookStoreProvider, usePBStore } from '../store/provider'
import { Store } from '../store/type'
import { Router } from 'next/router'
import { selectSetCurrentPath } from '../store/selectors'

interface IAppContextProviderProps {
  brand: Brand
  lang: string
  environment: Store['environment']
  children: ReactNode
  currentPath: string
}

export const AppContextProvider = ({
  brand,
  lang,
  environment,
  currentPath,
  children,
}: IAppContextProviderProps): JSX.Element => {
  return (
    <PostBookStoreProvider
      currentPath={currentPath}
      brand={brand}
      environment={environment}
      lang={lang}
    >
      <NavigationMonitor>{children}</NavigationMonitor>
    </PostBookStoreProvider>
  )
}

const NavigationMonitor: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const setCurrentPath = usePBStore(selectSetCurrentPath)

  const onRouteChangeStart = (url: string) => {
    const indexOfQuery = url.indexOf('?')
    if (indexOfQuery !== -1) {
      url = url.slice(0, indexOfQuery)
    }
    const excludingBasePathAndLocaleAndQueries = url
      .split('/')
      .slice(3)
      .join('/')

    const newUrl = `/${excludingBasePathAndLocaleAndQueries}`
    setCurrentPath(newUrl)
  }

  useEffect(() => {
    Router.events.on('routeChangeStart', onRouteChangeStart)
    return () => {
      Router.events.off('routeChangeStart', onRouteChangeStart)
    }
  }, [])

  return children
}
